<template>
    <div class="card border-2"  :class="isValid? 'border-success':'border-danger'"> 
        <div style="text-align: center;" class="bg-green card-text p-2">
            CHECKLIST
        </div>
        <div class="card-body p-2">
            <b-row>
                <b-col v-for="item in checklist_items" :key="item.id" cols="12" class="mb-1">
                    <div class="d-flex">
                        <input
                        style="height: 1.5rem; width: 1.5rem; min-height: 1.5rem; min-width: 1.5rem;"
                        class="form-check-input me-2"
                        v-model="item.status"
                        type="checkbox"/>
                        <span class="pt-1">{{item.text}}</span>
                    </div>
                    <hr>
                </b-col>
            </b-row>
        </div>
    </div>
<!--
    <b-card>
        <div class="card-title">
            Checklist
        </div>

        <div class="p-1">
            <b-row>
                <b-col v-for="item in checklist_items" :key="item.id" cols="12" class="mb-1">
                    <div class="d-flex">
                        <input
                        style="height: 1.5rem; width: 1.5rem; min-height: 1.5rem; min-width: 1.5rem;"
                        class="form-check-input me-2"
                        v-model="item.status"
                        type="checkbox"/>
                        <span class="pt-1">{{item.text}}</span>
                    </div>
                    <hr>
                </b-col>
            </b-row>
        </div>
    </b-card>
-->

</template>

<script>
export default {
    data:() => ({
        isValid: false,
        sel: false,
        checklist_items:[
            {
                id: 0,
                text: 'Has merge keys',
                status: false,
            },
            {
                id: 1,
                text: 'Some other Item',
                status: true,
            },
            {
                id: 2,
                text: 'Item list check',
                status: false,
            },
            {
                id: 3,
                text: 'Has stuff',
                status: false,
            },
            {
                id: 4,
                text: 'Long penguin text with extra snow. Cold cold cold ice?',
                status: false,
            }
        ]
    }),
    watch:{
        checklist_items:{
            deep: true,
            handler(){
                let valid = true;
                if(this.checklist_items.length == 0){
                    valid = false;
                }
                else{
                    this.checklist_items.forEach((item)=>{
                        if(item.status == false){
                            valid = false;
                        }
                    })
                    
                }
                this.isValid = valid;
                this.$emit('checkboxStatus', valid);
            }
        }
    },
    computed:{
        
    },
    methods:{},
    mounted(){},
}
</script>

<style>
.customstyle{
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    
    font-family: "Poppins", sans-serif;
    font-size: 0.8125rem;
    -webkit-box-direction: normal;
    word-wrap: break-word;
    line-height: 50px;
    font-weight: 500;
    color: #292d32;
    box-sizing: border-box;
    cursor: pointer;
    height: 20px;
    width: 20px;
    position: relative;
    box-shadow: inset 0 0 0 1px #ced4da;
    border-radius: 1px;
    display: block;
    float: left;
    /*margin: 15px 10px 0 20px;*/
}

.ckb-label{
        -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    --blue: #556ee6;
    --indigo: #564ab1;
    --purple: #6f42c1;
    --red: #f46a6a;
    --orange: #f1734f;
    --yellow: #f1b44c;
    --green: #34c38f;
    --teal: #050505;
    --cyan: #50a5f1;
    --white: #fff;
    --gray: #74788d;
    --gray-dark: #343a40;
    --primary: #556ee6;
    --secondary: #74788d;
    --success: #34c38f;
    --info: #50a5f1;
    --warning: #f1b44c;
    --danger: #f46a6a;
    --light: #eff2f7;
    --dark: #343a40;
    --pink: #e83e8c;
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --font-family-sans-serif: "Poppins", sans-serif;
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    --fc-daygrid-event-dot-width: 8px;
    --fc-list-event-dot-width: 10px;
    --fc-list-event-hover-bg-color: #f5f5f5;
    --ck-z-default: 1;
    --ck-z-modal: calc(var(--ck-z-default) + 999);
    --ck-color-base-foreground: #fafafa;
    --ck-color-base-background: #fff;
    --ck-color-base-border: #c4c4c4;
    --ck-color-base-action: #61b045;
    --ck-color-base-focus: #6cb5f9;
    --ck-color-base-text: #333;
    --ck-color-base-active: #198cf0;
    --ck-color-base-active-focus: #0e7fe1;
    --ck-color-base-error: #db3700;
    --ck-color-focus-border-coordinates: 208,79%,51%;
    --ck-color-focus-border: hsl(var(--ck-color-focus-border-coordinates));
    --ck-color-focus-outer-shadow: #bcdefb;
    --ck-color-focus-disabled-shadow: rgba(119,186,248,0.3);
    --ck-color-focus-error-shadow: rgba(255,64,31,0.3);
    --ck-color-text: var(--ck-color-base-text);
    --ck-color-shadow-drop: rgba(0,0,0,0.15);
    --ck-color-shadow-drop-active: rgba(0,0,0,0.2);
    --ck-color-shadow-inner: rgba(0,0,0,0.1);
    --ck-color-button-default-background: transparent;
    --ck-color-button-default-hover-background: #e6e6e6;
    --ck-color-button-default-active-background: #d9d9d9;
    --ck-color-button-default-active-shadow: #bfbfbf;
    --ck-color-button-default-disabled-background: transparent;
    --ck-color-button-on-background: #dedede;
    --ck-color-button-on-hover-background: #c4c4c4;
    --ck-color-button-on-active-background: #bababa;
    --ck-color-button-on-active-shadow: #a1a1a1;
    --ck-color-button-on-disabled-background: #dedede;
    --ck-color-button-action-background: var(--ck-color-base-action);
    --ck-color-button-action-hover-background: #579e3d;
    --ck-color-button-action-active-background: #53973b;
    --ck-color-button-action-active-shadow: #498433;
    --ck-color-button-action-disabled-background: #7ec365;
    --ck-color-button-action-text: var(--ck-color-base-background);
    --ck-color-button-save: #008a00;
    --ck-color-button-cancel: #db3700;
    --ck-color-switch-button-off-background: #b0b0b0;
    --ck-color-switch-button-off-hover-background: #a3a3a3;
    --ck-color-switch-button-on-background: var(--ck-color-button-action-background);
    --ck-color-switch-button-on-hover-background: #579e3d;
    --ck-color-switch-button-inner-background: var(--ck-color-base-background);
    --ck-color-switch-button-inner-shadow: rgba(0,0,0,0.1);
    --ck-color-dropdown-panel-background: var(--ck-color-base-background);
    --ck-color-dropdown-panel-border: var(--ck-color-base-border);
    --ck-color-input-background: var(--ck-color-base-background);
    --ck-color-input-border: #c7c7c7;
    --ck-color-input-error-border: var(--ck-color-base-error);
    --ck-color-input-text: var(--ck-color-base-text);
    --ck-color-input-disabled-background: #f2f2f2;
    --ck-color-input-disabled-border: #c7c7c7;
    --ck-color-input-disabled-text: #5c5c5c;
    --ck-color-list-background: var(--ck-color-base-background);
    --ck-color-list-button-hover-background: var(--ck-color-button-default-hover-background);
    --ck-color-list-button-on-background: var(--ck-color-base-active);
    --ck-color-list-button-on-background-focus: var(--ck-color-base-active-focus);
    --ck-color-list-button-on-text: var(--ck-color-base-background);
    --ck-color-panel-background: var(--ck-color-base-background);
    --ck-color-panel-border: var(--ck-color-base-border);
    --ck-color-toolbar-background: var(--ck-color-base-foreground);
    --ck-color-toolbar-border: var(--ck-color-base-border);
    --ck-color-tooltip-background: var(--ck-color-base-text);
    --ck-color-tooltip-text: var(--ck-color-base-background);
    --ck-color-engine-placeholder-text: #707070;
    --ck-color-upload-bar-background: #6cb5f9;
    --ck-color-link-default: #0000f0;
    --ck-color-link-selected-background: rgba(31,177,255,0.1);
    --ck-color-link-fake-selection: rgba(31,177,255,0.3);
    --ck-disabled-opacity: .5;
    --ck-focus-outer-shadow-geometry: 0 0 0 3px;
    --ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);
    --ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);
    --ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);
    --ck-focus-ring: 1px solid var(--ck-color-focus-border);
    --ck-font-size-base: 13px;
    --ck-line-height-base: 1.84615;
    --ck-font-face: Helvetica,Arial,Tahoma,Verdana,Sans-Serif;
    --ck-font-size-tiny: 0.7em;
    --ck-font-size-small: 0.75em;
    --ck-font-size-normal: 1em;
    --ck-font-size-big: 1.4em;
    --ck-font-size-large: 1.8em;
    --ck-ui-component-min-height: 2.3em;
    --ck-border-radius: 2px;
    --ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;
    --ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);
    --ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);
    --ck-spacing-unit: 0.6em;
    --ck-spacing-large: calc(var(--ck-spacing-unit)*1.5);
    --ck-spacing-standard: var(--ck-spacing-unit);
    --ck-spacing-medium: calc(var(--ck-spacing-unit)*0.8);
    --ck-spacing-small: calc(var(--ck-spacing-unit)*0.5);
    --ck-spacing-tiny: calc(var(--ck-spacing-unit)*0.3);
    --ck-spacing-extra-tiny: calc(var(--ck-spacing-unit)*0.16);
    --ck-color-editable-blur-selection: #d9d9d9;
    --ck-dropdown-arrow-size: calc(0.5*var(--ck-icon-size));
    --ck-icon-size: calc(var(--ck-line-height-base)*var(--ck-font-size-normal));
    --ck-tooltip-arrow-size: 5px;
    --ck-switch-button-toggle-width: 2.6153846154em;
    --ck-switch-button-toggle-inner-size: 1.0769230769em;
    --ck-switch-button-toggle-spacing: 1px;
    --ck-switch-button-translation: calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2*var(--ck-switch-button-toggle-spacing));
    --ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);
    --ck-balloon-arrow-offset: 2px;
    --ck-balloon-arrow-height: 10px;
    --ck-balloon-arrow-half-width: 8px;
    --ck-widget-type-around-button-size: 20px;
    --ck-color-widget-type-around-button-active: var(--ck-color-focus-border);
    --ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);
    --ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);
    --ck-color-widget-type-around-button-radar-start-alpha: 0;
    --ck-color-widget-type-around-button-radar-end-alpha: .3;
    --ck-color-widget-type-around-button-icon: var(--ck-color-base-background);
    --ck-color-resizer: var(--ck-color-focus-border);
    --ck-resizer-size: 10px;
    --ck-resizer-border-width: 1px;
    --ck-resizer-border-radius: 2px;
    --ck-resizer-offset: calc(var(--ck-resizer-size)/-2 - 2px);
    --ck-resizer-tooltip-offset: 10px;
    --ck-color-resizer-tooltip-background: #262626;
    --ck-color-resizer-tooltip-text: #f2f2f2;
    --ck-widget-outline-thickness: 3px;
    --ck-widget-handler-icon-size: 16px;
    --ck-widget-handler-animation-duration: 200ms;
    --ck-widget-handler-animation-curve: ease;
    --ck-color-widget-blurred-border: #dedede;
    --ck-color-widget-hover-border: #ffc83d;
    --ck-color-widget-editable-focus-background: var(--ck-color-base-background);
    --ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);
    --ck-input-text-width: 18em;
    --ck-balloon-fake-panel-offset-horizontal: 6px;
    --ck-balloon-fake-panel-offset-vertical: 6px;
    --ck-color-split-button-hover-background: #ebebeb;
    --ck-color-split-button-hover-border: #b3b3b3;
    --ck-color-image-upload-icon: #fff;
    --ck-color-image-upload-icon-background: #008a00;
    --ck-image-upload-icon-size: 20px;
    --ck-image-upload-icon-width: 2px;
    --ck-color-upload-placeholder-loader: #b3b3b3;
    --ck-upload-placeholder-loader-size: 32px;
    --ck-image-style-spacing: 1.5em;
    --ck-media-embed-placeholder-icon-size: 3em;
    --ck-color-media-embed-placeholder-url-text: #757575;
    --ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);
    --ck-color-table-focused-cell-background: rgba(158,207,250,0.3);
    --ck-insert-table-dropdown-padding: 10px;
    --ck-insert-table-dropdown-box-height: 11px;
    --ck-insert-table-dropdown-box-width: 12px;
    --ck-insert-table-dropdown-box-margin: 1px;
    --ck-table-selected-cell-background: rgba(158,207,250,0.3);
    -webkit-box-direction: normal;
    word-wrap: break-word;
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    overflow: visible;
    box-sizing: border-box;
    padding: 0;
    opacity: 0;
    cursor: pointer;
}

.chb-inner{
        -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    --blue: #556ee6;
    --indigo: #564ab1;
    --purple: #6f42c1;
    --red: #f46a6a;
    --orange: #f1734f;
    --yellow: #f1b44c;
    --green: #34c38f;
    --teal: #050505;
    --cyan: #50a5f1;
    --white: #fff;
    --gray: #74788d;
    --gray-dark: #343a40;
    --primary: #556ee6;
    --secondary: #74788d;
    --success: #34c38f;
    --info: #50a5f1;
    --warning: #f1b44c;
    --danger: #f46a6a;
    --light: #eff2f7;
    --dark: #343a40;
    --pink: #e83e8c;
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --font-family-sans-serif: "Poppins", sans-serif;
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    --fc-daygrid-event-dot-width: 8px;
    --fc-list-event-dot-width: 10px;
    --fc-list-event-hover-bg-color: #f5f5f5;
    --ck-z-default: 1;
    --ck-z-modal: calc(var(--ck-z-default) + 999);
    --ck-color-base-foreground: #fafafa;
    --ck-color-base-background: #fff;
    --ck-color-base-border: #c4c4c4;
    --ck-color-base-action: #61b045;
    --ck-color-base-focus: #6cb5f9;
    --ck-color-base-text: #333;
    --ck-color-base-active: #198cf0;
    --ck-color-base-active-focus: #0e7fe1;
    --ck-color-base-error: #db3700;
    --ck-color-focus-border-coordinates: 208,79%,51%;
    --ck-color-focus-border: hsl(var(--ck-color-focus-border-coordinates));
    --ck-color-focus-outer-shadow: #bcdefb;
    --ck-color-focus-disabled-shadow: rgba(119,186,248,0.3);
    --ck-color-focus-error-shadow: rgba(255,64,31,0.3);
    --ck-color-text: var(--ck-color-base-text);
    --ck-color-shadow-drop: rgba(0,0,0,0.15);
    --ck-color-shadow-drop-active: rgba(0,0,0,0.2);
    --ck-color-shadow-inner: rgba(0,0,0,0.1);
    --ck-color-button-default-background: transparent;
    --ck-color-button-default-hover-background: #e6e6e6;
    --ck-color-button-default-active-background: #d9d9d9;
    --ck-color-button-default-active-shadow: #bfbfbf;
    --ck-color-button-default-disabled-background: transparent;
    --ck-color-button-on-background: #dedede;
    --ck-color-button-on-hover-background: #c4c4c4;
    --ck-color-button-on-active-background: #bababa;
    --ck-color-button-on-active-shadow: #a1a1a1;
    --ck-color-button-on-disabled-background: #dedede;
    --ck-color-button-action-background: var(--ck-color-base-action);
    --ck-color-button-action-hover-background: #579e3d;
    --ck-color-button-action-active-background: #53973b;
    --ck-color-button-action-active-shadow: #498433;
    --ck-color-button-action-disabled-background: #7ec365;
    --ck-color-button-action-text: var(--ck-color-base-background);
    --ck-color-button-save: #008a00;
    --ck-color-button-cancel: #db3700;
    --ck-color-switch-button-off-background: #b0b0b0;
    --ck-color-switch-button-off-hover-background: #a3a3a3;
    --ck-color-switch-button-on-background: var(--ck-color-button-action-background);
    --ck-color-switch-button-on-hover-background: #579e3d;
    --ck-color-switch-button-inner-background: var(--ck-color-base-background);
    --ck-color-switch-button-inner-shadow: rgba(0,0,0,0.1);
    --ck-color-dropdown-panel-background: var(--ck-color-base-background);
    --ck-color-dropdown-panel-border: var(--ck-color-base-border);
    --ck-color-input-background: var(--ck-color-base-background);
    --ck-color-input-border: #c7c7c7;
    --ck-color-input-error-border: var(--ck-color-base-error);
    --ck-color-input-text: var(--ck-color-base-text);
    --ck-color-input-disabled-background: #f2f2f2;
    --ck-color-input-disabled-border: #c7c7c7;
    --ck-color-input-disabled-text: #5c5c5c;
    --ck-color-list-background: var(--ck-color-base-background);
    --ck-color-list-button-hover-background: var(--ck-color-button-default-hover-background);
    --ck-color-list-button-on-background: var(--ck-color-base-active);
    --ck-color-list-button-on-background-focus: var(--ck-color-base-active-focus);
    --ck-color-list-button-on-text: var(--ck-color-base-background);
    --ck-color-panel-background: var(--ck-color-base-background);
    --ck-color-panel-border: var(--ck-color-base-border);
    --ck-color-toolbar-background: var(--ck-color-base-foreground);
    --ck-color-toolbar-border: var(--ck-color-base-border);
    --ck-color-tooltip-background: var(--ck-color-base-text);
    --ck-color-tooltip-text: var(--ck-color-base-background);
    --ck-color-engine-placeholder-text: #707070;
    --ck-color-upload-bar-background: #6cb5f9;
    --ck-color-link-default: #0000f0;
    --ck-color-link-selected-background: rgba(31,177,255,0.1);
    --ck-color-link-fake-selection: rgba(31,177,255,0.3);
    --ck-disabled-opacity: .5;
    --ck-focus-outer-shadow-geometry: 0 0 0 3px;
    --ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);
    --ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);
    --ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);
    --ck-focus-ring: 1px solid var(--ck-color-focus-border);
    --ck-font-size-base: 13px;
    --ck-line-height-base: 1.84615;
    --ck-font-face: Helvetica,Arial,Tahoma,Verdana,Sans-Serif;
    --ck-font-size-tiny: 0.7em;
    --ck-font-size-small: 0.75em;
    --ck-font-size-normal: 1em;
    --ck-font-size-big: 1.4em;
    --ck-font-size-large: 1.8em;
    --ck-ui-component-min-height: 2.3em;
    --ck-border-radius: 2px;
    --ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;
    --ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);
    --ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);
    --ck-spacing-unit: 0.6em;
    --ck-spacing-large: calc(var(--ck-spacing-unit)*1.5);
    --ck-spacing-standard: var(--ck-spacing-unit);
    --ck-spacing-medium: calc(var(--ck-spacing-unit)*0.8);
    --ck-spacing-small: calc(var(--ck-spacing-unit)*0.5);
    --ck-spacing-tiny: calc(var(--ck-spacing-unit)*0.3);
    --ck-spacing-extra-tiny: calc(var(--ck-spacing-unit)*0.16);
    --ck-color-editable-blur-selection: #d9d9d9;
    --ck-dropdown-arrow-size: calc(0.5*var(--ck-icon-size));
    --ck-icon-size: calc(var(--ck-line-height-base)*var(--ck-font-size-normal));
    --ck-tooltip-arrow-size: 5px;
    --ck-switch-button-toggle-width: 2.6153846154em;
    --ck-switch-button-toggle-inner-size: 1.0769230769em;
    --ck-switch-button-toggle-spacing: 1px;
    --ck-switch-button-translation: calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2*var(--ck-switch-button-toggle-spacing));
    --ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);
    --ck-balloon-arrow-offset: 2px;
    --ck-balloon-arrow-height: 10px;
    --ck-balloon-arrow-half-width: 8px;
    --ck-widget-type-around-button-size: 20px;
    --ck-color-widget-type-around-button-active: var(--ck-color-focus-border);
    --ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);
    --ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);
    --ck-color-widget-type-around-button-radar-start-alpha: 0;
    --ck-color-widget-type-around-button-radar-end-alpha: .3;
    --ck-color-widget-type-around-button-icon: var(--ck-color-base-background);
    --ck-color-resizer: var(--ck-color-focus-border);
    --ck-resizer-size: 10px;
    --ck-resizer-border-width: 1px;
    --ck-resizer-border-radius: 2px;
    --ck-resizer-offset: calc(var(--ck-resizer-size)/-2 - 2px);
    --ck-resizer-tooltip-offset: 10px;
    --ck-color-resizer-tooltip-background: #262626;
    --ck-color-resizer-tooltip-text: #f2f2f2;
    --ck-widget-outline-thickness: 3px;
    --ck-widget-handler-icon-size: 16px;
    --ck-widget-handler-animation-duration: 200ms;
    --ck-widget-handler-animation-curve: ease;
    --ck-color-widget-blurred-border: #dedede;
    --ck-color-widget-hover-border: #ffc83d;
    --ck-color-widget-editable-focus-background: var(--ck-color-base-background);
    --ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);
    --ck-input-text-width: 18em;
    --ck-balloon-fake-panel-offset-horizontal: 6px;
    --ck-balloon-fake-panel-offset-vertical: 6px;
    --ck-color-split-button-hover-background: #ebebeb;
    --ck-color-split-button-hover-border: #b3b3b3;
    --ck-color-image-upload-icon: #fff;
    --ck-color-image-upload-icon-background: #008a00;
    --ck-image-upload-icon-size: 20px;
    --ck-image-upload-icon-width: 2px;
    --ck-color-upload-placeholder-loader: #b3b3b3;
    --ck-upload-placeholder-loader-size: 32px;
    --ck-image-style-spacing: 1.5em;
    --ck-media-embed-placeholder-icon-size: 3em;
    --ck-color-media-embed-placeholder-url-text: #757575;
    --ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);
    --ck-color-table-focused-cell-background: rgba(158,207,250,0.3);
    --ck-insert-table-dropdown-padding: 10px;
    --ck-insert-table-dropdown-box-height: 11px;
    --ck-insert-table-dropdown-box-width: 12px;
    --ck-insert-table-dropdown-box-margin: 1px;
    --ck-table-selected-cell-background: rgba(158,207,250,0.3);
    font-family: "Poppins", sans-serif;
    font-size: 0.8125rem;
    -webkit-box-direction: normal;
    word-wrap: break-word;
    line-height: 50px;
    color: #292d32;
    box-sizing: border-box;
    display: inline-block;
    font-weight: 500;
    position: absolute;
    height: 20px;
    width: 20px;
    left: 0;
    cursor: pointer;
    opacity: 0;
    margin-bottom: 0;
    transition-duration: 0.05s;
    top: 0;
}
</style>